<template>
    <v-app>
        <cheque-book-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />  
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Cheque Book Records</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">

                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.fullPath)"
                                                    @click="openChequeBook"
                                                    color="primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Cheque Book
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import chequeBookSetup from '@/components/module/accounts/chequeBook/chequeBookSetup.vue';

export default {
    components: {
        chequeBookSetup
    },
    data: () => ({
        itemsPerPage:10,
        panel: [0],
        loading:false,
        search: "",
        dialog: false,
        data:{},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Start Cheque No", key: "start_cheque_no",align: "left" ,sortable: false },
            { title: "End Cheque No", key: "end_cheque_no", align: "left", sortable: true },
            { title: "Bank Account",align: "left", key: "bank_account.account_no", sortable: true },
            { title: "Received Date",align: "left", key: "received_date", sortable: true },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
    }),
    watch: {
    },
    created(){
        if(this.$store.getters.getChequeBookList.length == 0){
            this.loading = true;
            this.$store.dispatch('getChequeBookList').then((response) => {
                this.loading = false;
            })
        };
        
    },
    computed:{
        getSchema() {
            return this.$store.getters.getChequeBookList;
        },
    },
    methods: {
        openChequeBook() {
            this.data = {
                start_cheque_no: "",
                end_cheque_no: "",
                bank_account_head_id: null,
                received_date: null,
            };
            this.dialog = true;
        },
        editItem(item){
            this.data = { ...item };
            console.log(this.data)
            this.dialog = true;
        },

        formatExportData() {
            let sl = 1;
            return this.getSchema.map(item => (
                [sl++, item.start_cheque_no ?? '', item.end_cheque_no ?? '', item.bank_account?.name ?? '', item.received_date ?? '', item.status == 1 ? 'Active' : 'Inactive']
            ));
        },

        exportToPDF() {
            const columns = [ '#SL', 'Start Cheque No', 'End Cheque No', 'Bank Account Head', 'Received Date', 'Status' ];
            const rows = this.formatExportData();

            this.$exportTableToPDF(
                columns,
                rows,
                'Cheque Book List',
                'cheque_book_list_' + this.$fileDate()
            );
        },

        exportToExcel() {
            const data = [
                [ '#SL', 'Start Cheque No', 'End Cheque No', 'Bank Account Head', 'Received Date', 'Status' ],
                ...this.formatExportData()
            ];

            this.$exportTableToExcel(
                data,
                'cheque_book_list_' + this.$fileDate()
            );
        },

        exportToCSV() {
            const data = [
                [ '#SL', 'Start Cheque No', 'End Cheque No', 'Bank Account Head', 'Received Date', 'Status' ],
                ...this.formatExportData()
            ];

            this.$exportTableToCSV(
                data,
                'cheque_book_list_' + this.$fileDate()
            );
        }
    },
    mounted() {

    }  
}
</script>